import { usingGet } from '@ocean/api'

export const getListSimulatorExercises = () => usingGet('SimulatorTrainings/ListSimulatorExercises')
